let tableColumnData = [
  {
    label: '',
    background: '#def0d6',
    type: 'project',
    children: [
      { label: '序号', key: 'serialNumber', showInLiteVersion: true, width: 50 },
      { label: '直接交易主体', key: 'fundNameProject', showInLiteVersion: true },
      { label: '项目简称', key: 'portFolio', showInLiteVersion: true }
    ]
  },
  {
    label: 'Portfolio基础信息',
    background: '#def0d6',
    type: 'project',
    children: [
      // { label: '项目简称', key: 'portFolio' },
      { label: '项目状态-by基金', key: 'companyAndInvestFundStatus', showInLiteVersion: true },
      { label: '退出状态', key: 'exitStatus', showInLiteVersion: true },
      { label: '工商名称', key: 'businessName' },
      { label: '公司注册地', key: 'registerRegion' },
      { label: '所属赛道', key: 'bussiness', showInLiteVersion: true },
      { label: '是否522', key: 'isFivett' },
      { label: '是否中小企业', key: 'isSmes' },
      { label: '一句话简介', key: 'description' },
      { label: '项目DL(天池)/投后管理对接人', key: 'projectPeopleName' },
      { label: '董事会席位源码代理人', key: 'ourBoardPerson' },
      { label: '项目来源', key: 'companySource' },
      { label: 'Initial/Follow-on', key: 'nodeType' },
      { label: '项目架构', key: 'companyStructure' }
    ]
  },
  {
    label: '退出信息-by项目',
    background: '#dbecf8',
    type: 'project',
    children: [
      { label: '退出总成本', key: 'totalCost', showInLiteVersion: true },
      { label: '退出总收入', key: 'totalProceeds', showInLiteVersion: true },
      { label: '退出总收益', key: 'totalIncome', showInLiteVersion: true },
      // { label: '退出部分在项目投资的比例', key: 'totalFullyDilutedOwnership', showInLiteVersion: true },
      { label: '退出部分总MOIC', key: 'exitMOIC', showInLiteVersion: true },
      { label: '退出部分IRR', key: 'irr', showInLiteVersion: true }
    ]
  },
  {
    label: '退出信息-by轮次',
    background: '#fff1c7',
    type: 'round',
    children: [
      { label: '持股轮次', key: 'classOfShare', showInLiteVersion: true },
      { label: 'Initial/Follow-on（交易）', key: 'nodeTypeRound', showInLiteVersion: true },
      { label: '投资日期', key: 'initialInvestmentDate', showInLiteVersion: true },
      { label: '退出部分投资成本', key: 'investmentCost', showInLiteVersion: true },
      { label: '退出金额', key: 'proceeds', showInLiteVersion: true },
      { label: '已分配金额', key: 'allocatedAmount' },
      { label: '退出回报', key: 'cumulativeUnrealized', showInLiteVersion: true },
      { label: '退出MOIC', key: 'MOIC', showInLiteVersion: true },
      { label: '退出收款日期', key: 'proceedDate', showInLiteVersion: true },
      { label: '退出方式', key: 'exitType', showInLiteVersion: true },
      { label: '退出对手方（上市地点/收购方/股权受让方）', key: 'exitOpponent' },
      { label: '实际退出股数', key: 'shareNum', showInLiteVersion: true },
      { label: '退出部分股比', key: 'fullyDilutedOwnership' },
      { label: '退出每股单价', key: 'amountPerShareNum', showInLiteVersion: true },
      { label: '退出时点公司估值', key: 'proceedValuation', showInLiteVersion: true }
    ]
  },
  {
    label: '交易记录-原始投资轮次信息',
    background: '#ffe48d',
    type: 'round',
    children: [
      { label: '本轮交易类型', key: 'investDealType' },
      { label: '本轮交易轮次', key: 'investClassOfShareId' },
      { label: '企业所处轮次', key: 'investThisClassOfShareId' },
      { label: '直接交易主体', key: 'investFundName' },
      { label: '穿透最终投资主体及投资成本', key: 'investPenetrateFund' },
      { label: '投资币种', key: 'investCurrency' },
      { label: '财务交割日期', key: 'investDeliveryDate' },
      { label: '实际投资金额', key: 'investAmount' },
      { label: '本轮持有股数', key: 'investShareNum' },
      { label: '投时持股占比', key: 'investPreShareScale' },
      { label: '原始交易每股单价', key: 'investShareUnitPrice' },
      { label: '本轮融资总金额', key: 'investFinancingAllAmount' },
      { label: '共同投资人及其投资金额', key: 'investOtherInvestors' },
      { label: '本轮DL', key: 'investDlName' },
      { label: '本轮DDL', key: 'investDdlName' },
      { label: '本轮所属BU', key: 'investBu' },
      { label: '是否领投', key: 'investEnterExitType' }
      // { label: '回购截止时间', key: 'investBuybackDeadline' },
    ]
  },
  {
    label: '交易记录-原始投资时点估值信息',
    background: '#ffc9a9',
    type: 'round',
    children: [
      { label: '估值币种', key: 'investOriginalValuationCurrency' },
      { label: '估值币种记账日汇率', key: 'investOriginalBookRate' },
      { label: '投前估值', key: 'investOriginalPreValuation' },
      { label: '投后估值', key: 'investOriginalPostValuation' },
      { label: '企业总股数', key: 'investOriginalTotalShareNum' },
      { label: '估值每股单价', key: 'investOriginalShareUnitPrice' }
    ]
  },
  {
    label: 'FMV调整',
    background: '#ffcbc3',
    type: 'round',
    children: [
      { label: '计算FMV时本轮应用的估值每股单价 ', key: 'investThisShareUnitPrice' },
      { label: 'FMV手动调整', key: 'investAdjust' }
    ]
  },
  {
    label: '其他',
    background: '#ededed',
    type: 'round',
    children: [
      { label: '投后新增轮次融资情况', key: 'newRoundOfFinancingAfterInvestment' },
      { label: '说明/备注', key: 'remark', showInLiteVersion: true }
    ]
  }
];

let count = 0;
let tableColumnDataWithCount = tableColumnData.map(item => {
  return {
    ...item,
    count: item.children.length,
    children: item.children.map((child, index) => {
      return {
        ...child,
        index: count++
      };
    })
  };
});

// 生成一个map,格式为{num: color},其中num为列数，color为背景色
let countSum = 0;
export const colorMap = tableColumnDataWithCount.map(cur => {
  countSum += cur.count;
  return {
    count: countSum,
    color: cur.background
  };
}, {});
console.log('colorMap2', colorMap);

// 导出精简版展示的表头index数组
export const liteVersionMap = tableColumnDataWithCount.reduce((prev, cur) => {
  return prev.concat(
    cur.children
      .filter(_ => _.showInLiteVersion)
      .map(item => {
        return item.index;
      })
  );
}, []);
console.log('liteVersionMap', liteVersionMap);

// 最终展示的数据在structData里
export const structData = [
  tableColumnDataWithCount.reduce((prev, cur) => {
    return prev.concat(
      cur.children.map((item, index) => {
        return {
          value: item.label,
          border: item.label === '项目简称' ? 1 : 0,
          // border: (index===cur.children.length-1) ? 1 : 0,
          // border: 0,
          background: cur.background,
          bold: true,
          index: item.index,
          eleProperty: [],
          textAlign: !cur.label ? 'left' : 'right'
        };
      })
    );
  }, [])
];

console.log(structData);

export const columnMap = tableColumnDataWithCount.reduce((prev, cur) => {
  return prev.concat(
    cur.children.map(item => {
      return item.key;
    })
  );
}, []);

export const settings = {
  licenseKey: 'non-commercial-and-evaluation',
  data: [],
  rowHeaders: false,
  height: 120 + 17 * 30,
  width: '100%',
  hiddenColumns: {
    columns: [],
    indicators: true
  },
  // renderAllRows: true,// 一次性渲染所有行
  // viewportColumnRenderingOffset: 100,// 关闭虚拟列渲染,避免出现列高度不一致的问题

  rowHeights: 30,
  colWidths: tableColumnDataWithCount.reduce((prev, cur) => {
    return prev.concat(
      cur.children.map(item => {
        return item.width ? item.width : '100';
      })
    );
  }, []),

  // 表头
  nestedHeaders: [
    // 表头第一行
    tableColumnDataWithCount.map((e, index) => {
      return {
        label: e.label,
        colspan: e.count
      };
    }),
    // 表头第二行
    tableColumnDataWithCount.reduce((prev, cur) => {
      return prev.concat(
        cur.children.map((e, index) => {
          return {
            label: e.label,
            colspan: 1
          };
        })
      );
    }, [])
  ],
  // colWidths: Array(structData[0].length).fill(100),
  columns: Array(structData[0].length).fill({}),
  afterRenderer: (td, row, col, prop, value, cellProperties) => {
    renderStyle(td, row, col, prop, value, cellProperties);
    return td;
  }
};

// sumMap组合一下
const sumMapEdit = {
  portFolio: 'serialNumber',
  totalCost: 'totalCost',
  totalProceeds: 'totalProceeds',
  totalIncome: 'totalIncome',
  totalMOIC: 'exitMOIC', // 退出部分总moic
  investmentCost: 'investmentCost',
  proceedsSum: 'proceeds',
  cumulativeUnrealized: 'cumulativeUnrealized',
  MOIC: 'MOIC'
};

// 遍历sumMap,把key转换成对应字段的index
export const sumMap = Object.fromEntries(
  Object.entries(sumMapEdit).map(([key, value]) => {
    return [
      key,
      tableColumnDataWithCount
        .reduce((prev, cur) => {
          return prev.concat(
            cur.children.map((item, index) => {
              return item.key;
            })
          );
        }, [])
        .indexOf(value)
    ];
  })
);

// 展示在project行的数据
export const projectMap = Object.fromEntries(
  tableColumnDataWithCount
    .filter(_ => _.type === 'project')
    .reduce((acc, cur) => {
      return acc.concat(cur.children.map((e, index) => [e.key, e.index]));
    }, [])
);

// 展示在round行的数据
export const fundMap = Object.fromEntries(
  tableColumnDataWithCount
    .filter(_ => _.type === 'round')
    .reduce((acc, cur) => {
      return acc.concat(cur.children.map((e, index) => [e.key, e.index]));
    }, [])
);

export const precisionMap = {
  zerobit: [
    'totalFMV',
    'totalIncome',
    'fairValue',
    'cumulativeUnrealized',
    'latestPreValuation',
    'latestPostValuation',
    'amount',
    'financingAllAmount',
    'originalPreValuation',
    'originalPostValuation',
    'eventAmount',
    'investShareNum',
    'cumulativeUnrealized'
  ],
  twobit: [
    'totalCost',
    'totalProceeds',
    'totalIncome',
    'investmentCost',
    'proceeds',
    'allocatedAmount',
    'cumulativeUnrealized',
    'proceedValuation',
    'investAmount',
    'investFinancingAllAmount',
    'investOriginalPreValuation',
    'investOriginalPostValuation',
    'latestValuationPerShare',
    'shareUnitPrice',
    'pricePerShare',
    'thisShareUnitPrice',
    'adjust',
    'eventAmountUnitShare',
    'amountPerShareNum',
    'investShareUnitPrice',
    'investPricePerShare',
    'investOriginalShareUnitPrice',
    'investThisShareUnitPrice',
    'investAdjust',
    'totalFullyDilutedOwnership',
    'fullyDilutedOwnership',
    'investPreShareScale',
    'irr'
  ],
  fourbit: ['totalMOIC', 'MOIC', 'latestBookRate', 'originalBookRate', 'eventSharePer', 'reportRate', 'exitMOIC', 'investOriginalBookRate']
};

function renderStyle(td, row, col, prop, value, cellProperties) {
  const obj = Object.assign({}, structData[row + 1][col]);
  Object.assign(td.style, obj.style);
  // console.log('renderStyle', row, col, prop, value);
  // 如果col小于等于2,切换class
  let className = col <= 2 ? 'handsontable-text-tooltip htt-left' : 'handsontable-text-tooltip htt-right';
  className += (typeof value === 'string' && value.length) > 15 ? ' htt-long' : '';
  td.innerHTML = `<span style="white-space: nowrap" class="handsontable-text">
    <div class="${className}">
    ${obj.innerHTML}
    </div>
    ${obj.innerHTML}
  </span>`;
  // td.innerHTML = obj.innerHTML;
  cellProperties.readOnly = obj.readOnly;
}
